import PropTypes from 'prop-types'

export const trackItem = PropTypes.shape({
	id: PropTypes.number,
	title: PropTypes.string,
	duration: PropTypes.number,
	media_number: PropTypes.number,
	album: PropTypes.string,
	albumId: PropTypes.string,
	cover: PropTypes.string,
	artist: PropTypes.string,
	artistId: PropTypes.number,
	label: PropTypes.string,
	sampleable: PropTypes.bool
})

export const image = PropTypes.shape({
	thumbnail: PropTypes.string,
	back: PropTypes.string,
	small: PropTypes.string,
	large: PropTypes.string
})

export const album = PropTypes.shape({
	id: PropTypes.number,
	title: PropTypes.string,
	image,
	artist: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	tracks_count: PropTypes.number,
	duration: PropTypes.number,
	isQobuzissime: PropTypes.bool,
	description: PropTypes.string
})

export const playlist = PropTypes.shape({
	id: PropTypes.number,
	name: PropTypes.string,
	images: PropTypes.arrayOf(PropTypes.string),
	backgroundImage: PropTypes.string,
	trackCount: PropTypes.number,
	duration: PropTypes.number,
	description: PropTypes.string,
	owner: PropTypes.string,
	genres: PropTypes.arrayOf(PropTypes.string)
})

export const albumCard = PropTypes.shape({
	id: PropTypes.string,
	title: PropTypes.string,
	artist: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	track_count: PropTypes.number,
	image: PropTypes.string,
	released_at: PropTypes.number,
	sampleable: PropTypes.bool,
	hires: PropTypes.bool,
	genre: PropTypes.string,
	award: PropTypes.string,
	description: PropTypes.string
})

export const focusTitle = PropTypes.shape({
	type: PropTypes.string,
	title: PropTypes.string,
	accroche: PropTypes.string,
	author: PropTypes.string,
	date: PropTypes.string
})

export const focusImage = PropTypes.shape({
	type: PropTypes.string,
	image: PropTypes.string,
	credits: PropTypes.string
})

const focusText = PropTypes.shape({
	position: PropTypes.number,
	type: PropTypes.string,
	description: PropTypes.string
})

const focusCarousel = PropTypes.shape({
	position: PropTypes.number,
	type: PropTypes.string,
	number_col: PropTypes.string,
	number_raw: PropTypes.string,
	title: PropTypes.string,
	product_ids: PropTypes.string,
	albums: PropTypes.object,
	genre_ids: PropTypes.arrayOf(PropTypes.string)
})

export const focusContent = PropTypes.oneOfType([
	focusText,
	focusCarousel,
])



// WEBPACK FOOTER //
// ./src/constant/shapes.js